module.exports = __webpack_public_path__ + "img/coop-model.ee589fd6.png";